export const config = {
  resource: [
    { src: require('@/assets/images/game/linker/bg.png'), id: 'bg' },
    { src: require('@/assets/images/game/linker/title.png'), id: 'title' },
    { src: require('@/assets/images/game/linker/as.png'), id: 'btn' },
    { src: require('@/assets/images/game/linker/s.png'), id: 'tiger' },
    { src: require('@/assets/images/game/linker/lbg.jpg'), id: 'back' },
    { src: require('@/assets/images/game/linker/pl1.png'), id: 'plantl' },
    { src: require('@/assets/images/game/linker/pr.png'), id: 'plantr' },
    { src: require('@/assets/images/game/linker/border.png'), id: 'border' },
    { src: require('@/assets/images/game/linker/bak.png'), id: 'goback' },
    { src: require('@/assets/images/game/linker/pro.png'), id: 'progressbox' },
    { src: require('@/assets/images/game/linker/wro.png'), id: 'wrong' },
    { src: require('@/assets/images/game/linker/score.png'), id: 'score' },
    { src: require('@/assets/images/game/linker/sound.png'), id: 'sound' },
    { src: require('@/assets/images/game/linker/nosound.png'), id: 'nosound' },
    { src: require('@/assets/images/game/linker/sound1.mp3'), id: 'over' },
    { src: require('@/assets/images/game/linker/click.mp3'), id: 'uio' },
    { src: require('@/assets/images/game/linker/dialog.png'), id: 'dialog' },
    { src: require('@/assets/images/game/linker/om.png'), id: 'onemore' },
    { src: require('@/assets/images/game/linker/gov.png'), id: 'goover' },
    { src: require('@/assets/images/game/linker/oma.png'), id: 'onemorea' },
    { src: require('@/assets/images/game/linker/gova.png'), id: 'goovera' },
    { src: require('@/assets/images/game/linker/logo.png'), id: 'logo' },
    { src: require('@/assets/images/game/linker/right.png'), id: 'right' },
    { src: require('@/assets/images/game/linker/jiayi.png'), id: 'jiayi' },
    { src: require('@/assets/images/game/linker/fi.png'), id: 'five' },
    { src: require('@/assets/images/game/linker/ft.png'), id: 'fifteen' },
    { src: require('@/assets/images/game/linker/hback.png'), id: 'hback' },
    { src: require('@/assets/images/game/linker/wordh.png'), id: 'wordh' },
    { src: require('@/assets/images/game/linker/progress.png'), id: 'progress' },
    { src: require('@/assets/images/game/linker/scorebg.png'), id: 'scorebg' },
    { src: require('@/assets/images/game/linker/selected.png'), id: 'selected' },
    { src: require('@/assets/images/game/linker/uns.png'), id: 'unselected' },
    { src: require('@/assets/images/game/linker/scorebg.png'), id: 'scorebg' },
    { src: require('@/assets/images/game/linker/mapBGM.mp3'), id: 'loop' },
    { src: require('@/assets/images/game/linker/score.mp3'), id: 'soundscore' },
    { src: require('@/assets/images/game/linker/error.mp3'), id: 'sounderror' },
    { src: require('@/assets/images/game/linker/impact.ttf'), id: 'myfont', type: 'font' },
  ],
};
